<script>
    import _ from 'lodash'

    const _DEFAULT_OPTIONS = {
        disabled: false, // disable button NOTE button will not really be disabled for readability
        absolute: false, // positioning of button element
        xSmall: false, // size of button x-small
        large: false, // size of button large (fab default) or small
        labelPercent: false, // show percent label instead of score / max label
        dense: false, // remove spacing in labels for dense mode
        width: '3',
        menu: false
    }

    export default {
        name: 'VRatingButton',
        props: {
            options: {
                type: Object,
                default: () => ({..._DEFAULT_OPTIONS})
            },
            disabled: {
                type: Boolean,
                default: _DEFAULT_OPTIONS.disabled
            },
            absolute: {
                type: Boolean,
                default: _DEFAULT_OPTIONS.absolute
            },
            dense: {
                type: Boolean,
                default: _DEFAULT_OPTIONS.dense
            },
            xSmall: {
                type: Boolean,
                default: _DEFAULT_OPTIONS.xSmall
            },
            large: {
                type: Boolean,
                default: _DEFAULT_OPTIONS.large
            },
            circleWidth: {
                type: String,
                default: _DEFAULT_OPTIONS.width
            },
            hint: {
                type: String,
                default: ''
            },
            toggleHint: {
                type: Boolean,
                default: false
            },
            menu: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showWeightingDialog: false,
                gfName: 'vgf-weighting-edit',
                gfConfig: {
                    header: this.$vuetify.lang.t('$vuetify.gfb.rating.weighting'),
                    size: 12,
                    destroy: true,
                    fieldstyle: 'outlined',
                    layoutClass: 'my-8',
                    tabindex: 90,
                    actions: ['cancel', 'apply'],
                    rows: [
                        [
                            {
                                name: 'weighting',
                                hint: this.$vuetify.lang.t('$vuetify.gfb.block.weightingHint'),
                                type: 'slider',
                                min: 0,
                                max: 100,
                                step: 1,
                                value: 100,
                                showInput: true,
                                tickLabels: [],
                                // tickLabels: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                                thumbLabel: 'always',
                                size: 12
                            }
                        ]
                    ]
                },
                gfCallbacks: {
                    onSubmitAction: this.emitWeighting.bind(this),
                    onCancelAction: this.closeWeightingDialog.bind(this)
                }
            }
        },

        computed: {
            isAbsolute() {
                return typeof this.options.absolute === 'boolean' ? this.options.absolute : this.absolute
            },
            isSmall() {
                return !this.large && !this.isXSmall
            },
            isXSmall() {
                return typeof this.options.xSmall === 'boolean' ? this.options.xSmall : this.xSmall
            },
            size() {
                if (this.$attrs.size) return this.$attrs.size
                return this.isXSmall ? 32 : !this.isSmall ? 46 : 40
            },
            btnBindings() {
                const absolute = this.isAbsolute
                const xSmall = this.isXSmall
                const small = this.isSmall
                const size = this.size
                // disable button in edit mode, but not custom rating for text/textarea
                const disabled = this.disabled && this.options.rating !== true
                return {
                    absolute,
                    disabled,
                    right: true,
                    top: true,
                    fab: true,
                    elevation: 0,
                    color: _.get(this.options, 'rating.color'),
                    xSmall,
                    small,
                    class: 'vgf-f__fab' + (this.btnLabel.length >= 6 ? ' vgf-f__fab--dense' : ''),
                    ripple: false,
                    width: size,
                    height: size
                }
            },
            btnLabel() {
                let label = this.options.labelPercent ? _.get(this.options, 'rating.labelPercent') : _.get(this.options, 'rating.label')
                label = label || ''
                if (this.dense || this.options.dense) label = label.replace(/ /g, '')
                return label
            },
            progressBindings() {
                return {
                    value: _.get(this.options, 'rating.percent'),
                    color: _.get(this.options, 'rating.progressColor'),
                    width: this.options.width || this.width,
                    size: this.size
                }
            },
            tooltip() {
                const hint = this.hint || _.get(this.options, 'rating.hint', '')
                const toggleHint = typeof this.options.toggleHint === 'boolean' ? this.options.toggleHint : this.toggleHint
                if (!toggleHint || this.disabled) return hint
                return hint + ' \n Klicken für Maximum oder Minimum'
            },
            hasMenu() {
                return typeof this.options.menu === 'boolean' ? this.options.menu : this.menu
            },
            menuBindings() {
                return {
                    absolute: this.isAbsolute,
                    right: true,
                    top: true,
                    small: true,
                    class: `vgf-f__fab-menu ${this.large ? 'vgf-f__fab-menu--large' : ''}`
                }
            },
            isExcluded() {
                return !!this.options.noRating || !!_.get(this.options, 'rating.noRating')
            },
            hasScroll() {
                return !!this.options.ratingScroll
            },
            canUp() {
                const rating = this.options.rating
                if (!rating) return false
                return rating.score < rating.max
            },
            canDown() {
                const rating = this.options.rating
                if (!rating) return false
                return rating.score > rating.min
            },
            showUp() {
                return !this.isExcluded && !this.disabled && this.hasMenu && this.hasScroll && this.canUp
            },
            showDown() {
                return !this.isExcluded && !this.disabled && this.hasMenu && this.hasScroll && this.canDown
            },
            weightingClass() {
                let _class = 'vgf-rating__weighting'
                if (this.large) _class += ' vgf-rating__weighting--large'
                if (this.disabled) _class += ' vgf-rating__weighting--disabled'
                return _class
            }
        },

        methods: {
            emit() {
                if (!this.disabled) this.$emit('fab')
            },
            emitMin() {
                if (!this.disabled) this.$emit('min')
            },
            emitMax() {
                if (!this.disabled) this.$emit('max')
            },
            emitExclude() {
                if (!this.disabled) this.$emit('exclude')
            },
            emitInclude() {
                if (!this.disabled) this.$emit('include')
            },
            emitUp() {
                if (!this.disabled) this.$emit('up')
            },
            emitDown() {
                if (!this.disabled) this.$emit('down')
            },
            emitWeighting(data) {
                this.closeWeightingDialog()
                if (!this.disabled) this.$emit('weighting', data.weighting)
            },
            editWeighting() {
                this.gfConfig.rows[0][0].value = !_.isUndefined(this.options.weighting) ? this.options.weighting : 100
                this.showWeightingDialog = true
            },
            closeWeightingDialog() {
                this.showWeightingDialog = false
            }
        }
    }
</script>

<template>
    <VTooltip bottom :disabled="!options.rating || !options.rating.hint">
        <template v-slot:activator="{ on }">
            <VBtn v-show="!isExcluded" v-bind="btnBindings" v-on="on" @click.left="emit">
                <VIcon v-if="options.rating === true">mdi-strategy</VIcon>
                <VProgressCircular v-else v-bind="progressBindings">{{ btnLabel }}</VProgressCircular>
            </VBtn>
            <VMenu v-show="!disabled && hasMenu" :close-on-content-click="true" bottom left>
                <template v-slot:activator="act">
                    <VBtn v-show="!disabled && hasMenu" v-bind="menuBindings" icon v-on="act.on">
                        <VIcon>mdi-dots-vertical</VIcon>
                    </VBtn>
                </template>

                <VList dense>
                    <VListItem v-if="!isExcluded" @click.left="emitMin">
                        <VListItemIcon>
                            <VIcon>mdi-checkbox-multiple-blank-outline</VIcon>
                        </VListItemIcon>
                        <VListItemContent>
                            <VListItemTitle>{{ $vuetify.lang.t('$vuetify.gfb.rating.setmin') }}</VListItemTitle>
                        </VListItemContent>
                    </VListItem>
                    <VListItem v-if="!isExcluded" @click.left="emitMax">
                        <VListItemIcon>
                            <VIcon>mdi-checkbox-multiple-marked-outline</VIcon>
                        </VListItemIcon>
                        <VListItemContent>
                            <VListItemTitle>{{ $vuetify.lang.t('$vuetify.gfb.rating.setmax') }}</VListItemTitle>
                        </VListItemContent>
                    </VListItem>
                    <VListItem v-if="!isExcluded" @click.left="emitExclude">
                        <VListItemIcon>
                            <VIcon>mdi-close-box-multiple-outline</VIcon>
                        </VListItemIcon>
                        <VListItemContent>
                            <VListItemTitle>{{ $vuetify.lang.t('$vuetify.gfb.rating.exclude') }}</VListItemTitle>
                        </VListItemContent>
                    </VListItem>
                    <VListItem v-if="isExcluded" @click.left="emitInclude">
                        <VListItemIcon>
                            <VIcon>mdi-pencil-box-multiple-outline</VIcon>
                        </VListItemIcon>
                        <VListItemContent>
                            <VListItemTitle>{{ $vuetify.lang.t('$vuetify.gfb.rating.include') }}</VListItemTitle>
                        </VListItemContent>
                    </VListItem>
                    <VDivider/>
                    <VListItem @click.left="editWeighting">
                        <VListItemIcon>
                            <VIcon>mdi-weight</VIcon>
                        </VListItemIcon>
                        <VListItemContent>
                            <VListItemTitle>{{ $vuetify.lang.t('$vuetify.gfb.rating.weighting') }}</VListItemTitle>
                        </VListItemContent>
                    </VListItem>
                </VList>
            </VMenu>
            <div v-show="!isExcluded && options.weighting>=0 && options.weighting<100" :class="weightingClass">
                {{options.weighting+'%'}}
            </div>
            <VIcon v-show="showUp" small :disabled="!canUp" class="vgf-rating-up" @click.left="emitUp">mdi-menu-up</VIcon>
            <VIcon v-show="showDown" small :disabled="!canDown" class="vgf-rating-down" @click.left="emitDown">mdi-menu-down</VIcon>
            <VDialog v-if="showWeightingDialog" v-model="showWeightingDialog" width="60%">
                <VGridform :name="gfName" :config="gfConfig" :callbacks="gfCallbacks"/>
            </VDialog>
        </template>
        <span v-if="tooltip" v-text="tooltip"/>
    </VTooltip>
</template>

<style lang="scss">
    .v-icon.vgf-rating-up {
        position: absolute;
        top: calc(50% - 40px) !important;
        right: -36px !important;
    }
    .v-icon.vgf-rating-down {
        position: absolute;
        top: calc(50% + 24px) !important;
        right: -36px !important;
    }
    .vgf-rating__weighting {
        position: absolute;
        top: calc(50% + 8px) !important;
        right: -82px !important;
        font-size: 10px;
        &.vgf-rating__weighting--disabled {
            top: calc(50% + 20px) !important;
            right: -38px !important;
        }
        &.vgf-rating__weighting--large {
            right: -92px !important;
            &.vgf-rating__weighting--disabled {
                right: -48px !important;
            }
        }
    }
    .v-progress-circular__info {
        font-size: 0.75rem;
        font-weight: bold;
        color: black;
        letter-spacing: 0;
    }
    .vgf-f__fab.v-size--small {
        .v-progress-circular__info {
            font-size: 0.65rem; // small needs smaller font-size to not overlap
            font-weight: bold;
            letter-spacing: 0;
        }
    }
    .vgf-f__fab.v-size--x-small {
        .v-progress-circular__info {
            font-size: 0.625rem; // x-small needs smaller font-size to not overlap
            font-weight: bold;
            letter-spacing: 0;
        }
    }
    .vgf-f__fab.vgf-f__fab--dense {
        .v-progress-circular__info {
            font-size: 0.55rem;
        }
    }
    .vgf-f__fab.v-btn--absolute {
        top: calc(50% - 23px) !important;
        right: -60px !important;
        &.v-size--small {
            top: calc(50% - 20px) !important;
            right: -48px !important;
        }
        &.v-size--x-small {
            top: calc(50% - 16px) !important;
            right: -30px !important;
        }
    }
    .vgf-f__fab-menu.v-btn--absolute {
        top: calc(50% - 14px) !important;
        right: -85px !important;
        &.vgf-f__fab-menu--large {
            top: calc(50% - 16px) !important;
            right: -95px !important;
        }
    }
</style>
